<template>
  <a href="/" class="ic-nav__link" @click.prevent="goRenovation">Ristruttura</a>
</template>

<script>
import { requestRenovationChoice } from '@/renovationCta.js'

export default {
  name: 'RenovationNavLink',
  methods: {
    // "Ristruttura" → the home page's "Realizzala" section CTA: open its "Come vuoi
    // iniziare?" choice popup (Videocall / Preventivo). The popup is a full-viewport
    // fixed overlay, so we deliberately don't scroll the background: the home's
    // scroll-pinned "Potential" section reflows on any programmatic jump and leaves
    // the target stranded (the same reason AgencyNavLink scrolls by hand). Route
    // home first when on another page, then signal once the section has mounted.
    goRenovation() {
      if (this.$route && this.$route.path === '/') {
        requestRenovationChoice()
      } else {
        this.$router.push('/').then(() => setTimeout(requestRenovationChoice, 250))
      }
    },
  },
}
</script>

<style scoped>
.ic-nav__link {
  font-size: 16px;
  font-weight: 500;
  color: var(--ic-ink, #1e1e1e);
  white-space: nowrap;
  padding: 10px 16px;
  border-radius: 999px;
  cursor: pointer;
  transition: background-color 0.18s ease;
}
/* Pill hover: same beige as "Agenzie" and the listings "Ordina" button. */
.ic-nav__link:hover { background-color: #f2efe7; }
/* La visibilità responsive è governata dal layout ospite (ImmaginaHeader:
   sotto 1024px il link vive nel drawer mobile, non più nascosto qui). */
</style>
